import { useState } from 'react';
import { useToast } from '../../../../../shared/hooks/use-toast';

/** Copies the status summary to the clipboard. Success is a toast; a browser that refuses (no permission, an insecure page) is told inline, since the text is still on screen to select. */
export function useCopyStatusSummary() {
  const toast = useToast();
  const [error, setError] = useState<string | null>(null);

  async function copy(text: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(text);
      setError(null);
      toast.success('Status summary copied');
    } catch {
      setError('Could not copy. Select the text above and copy it instead.');
    }
  }

  return { copy, error };
}
